@if (openActivate || openDeactivate) {
<div class="fixed w-screen h-screen bg-gray-600 top-0 bottom-0 left-0 right-0 overflow-hidden bg-opacity-60 z-30">
  <div class="h-full w-full flex justify-center items-center">
    <div class="bg-white rounded-[8px] absolute min-w-[450px] p-4 flex flex-col gap-4">
      @if (openActivate) {
      <p class="text-sm">Are you sure you want to activate <b>{{agreements[agreement_id].name}}</b>?</p>
      <div class="flex justify-end">
        <outline-button text="Cancel" (click)="cancelActivate()" [marginRight]="true" />
        <full-button text="Confirm" (click)="confirmActivate(agreements[agreement_id].agreement_id)" />
      </div>
      }
      @if (openDeactivate) {
      <p class="text-sm">Are you sure you want to retire <b>{{agreements[agreement_id].name}}</b>?</p>
      <div class="flex justify-end">
        <outline-button text="Cancel" (click)="cancelDeactivate()" [marginRight]="true" />
        <full-button text="Confirm" (click)="confirmDeactivate(agreements[agreement_id].agreement_id)" />
      </div>
      }
    </div>
  </div>
</div>
}
<breadcrumb endText="User Agreement Management" />
<div class="p-2 lg:pb-2 lg:m-5">
  <div class="flex justify-between items-center mb-4">
    <h1 class="text-xl font-semibold">
      User Agreement Management
    </h1>
    <outline-button text="Create Agreement" (click)="add()" [faIcon]="faAdd" />
  </div>
  <table class="w-full table-fixed border-separate border-spacing-0">
    <colgroup>
      <col class="w-1/2 lg:w-1/4" />
      <col class="hidden lg:table-column lg:w-[16%]" />
      <col class="hidden lg:table-column lg:w-[14%]" />
      <col class="hidden lg:table-column lg:w-[16%]" />
      <col />
    </colgroup>
    <thead>
      <tr class="h-[48px] text-left text-gray-500 text-xs font-semibold uppercase leading-tight">
        <th scope="col" class="bg-[#F4F6F8] rounded-l-[4px] pl-[16px] pr-2 font-semibold"
          [attr.aria-sort]="sortColumn === 'name'? (isAscending? 'ascending': 'descending'): null">
          <button class="flex items-center gap-1 uppercase hover:text-gray-700" (click)="sort('name')">
            Title
            <ng-container *ngTemplateOutlet="sortIcon; context: {column: 'name'}" />
          </button>
        </th>
        <th scope="col" class="hidden lg:table-cell bg-[#F4F6F8] px-2 font-semibold"
          [attr.aria-sort]="sortColumn === 'required'? (isAscending? 'ascending': 'descending'): null">
          <button class="flex items-center gap-1 uppercase hover:text-gray-700" (click)="sort('required')">
            Requirement
            <ng-container *ngTemplateOutlet="sortIcon; context: {column: 'required'}" />
          </button>
        </th>
        <th scope="col" class="hidden lg:table-cell bg-[#F4F6F8] px-2 font-semibold"
          [attr.aria-sort]="sortColumn === 'responses'? (isAscending? 'ascending': 'descending'): null">
          <button class="flex items-center gap-1 uppercase hover:text-gray-700" (click)="sort('responses')">
            Responses
            <ng-container *ngTemplateOutlet="sortIcon; context: {column: 'responses'}" />
          </button>
        </th>
        <th scope="col" class="hidden lg:table-cell bg-[#F4F6F8] px-2 font-semibold"
          [attr.aria-sort]="sortColumn === 'createdate'? (isAscending? 'ascending': 'descending'): null">
          <button class="flex items-center gap-1 uppercase hover:text-gray-700" (click)="sort('createdate')">
            Created
            <ng-container *ngTemplateOutlet="sortIcon; context: {column: 'createdate'}" />
          </button>
        </th>
        <th scope="col" class="bg-[#F4F6F8] rounded-r-[4px] pl-2 pr-[16px] font-semibold">
          Actions
        </th>
      </tr>
    </thead>
    <tbody>
      @if (!isLoading) {
      @for (agreement of agreements; track agreement.agreement_id; let i = $index) {
      <tr class="hover:bg-[#F9FAFB] transition-colors">
        <td class="pl-[16px] pr-2 py-3 align-middle border-b border-[#F1F3F5] text-sm">
          <button type="button" (click)="edit(agreement.agreement_id)"
            class="block max-w-full truncate text-left font-medium text-black/90 hover:text-rutgers-red hover:underline">
            {{agreement.name}}
          </button>
        </td>
        <td class="hidden lg:table-cell px-2 py-3 align-middle border-b border-[#F1F3F5]">
          @if (agreement.required) {
          <span
            class="inline-flex items-center rounded-full bg-[#FBEBEF] px-2 py-0.5 text-xs font-medium text-[#CC0033]">
            Mandatory
          </span>
          } @else {
          <span class="inline-flex items-center rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-600">
            Optional
          </span>
          }
        </td>
        <td class="hidden lg:table-cell px-2 py-3 align-middle border-b border-[#F1F3F5] text-sm">
          <button type="button" (click)="responses(agreement.agreement_id, agreement.name)"
            class="font-medium text-black/90 hover:text-rutgers-red hover:underline">
            {{agreement.responses}}
          </button>
        </td>
        <td class="hidden lg:table-cell px-2 py-3 align-middle border-b border-[#F1F3F5] text-sm text-gray-600">
          @if (agreement.createdate) {
          {{agreement.createdate | date: 'mediumDate'}}
          } @else {
          <span class="text-gray-400">—</span>
          }
        </td>
        <td class="pl-2 pr-[16px] py-3 align-middle border-b border-[#F1F3F5]">
          <div class="flex items-center gap-[12px]">
            <div
              class="p-0.5 rounded-lg outline outline-1 outline-offset-[-1px] outline-neutral-300 inline-flex justify-evenly items-start text-xs gap-0.5">
              <button [disabled]="agreement.effective_date === null"
                (click)="activateToggle(i, agreement.effective_date)"
                [ngClass]="agreement.effective_date === null? 'bg-[#E31717] text-white rounded-lg px-[12px] py-[6px] grow': 'rounded-lg px-[12px] py-[6px] hover:bg-gray-200 grow'">
                Inactive
              </button>
              <button [disabled]="agreement.effective_date !== null"
                (click)="activateToggle(i, agreement.effective_date)"
                [ngClass]="agreement.effective_date !== null? 'bg-[#118D57] text-white rounded-lg px-[12px] py-[6px] grow': 'rounded-lg px-[12px] py-[6px] hover:bg-gray-200 grow'">
                Active
              </button>
            </div>
            <button (click)="responses(agreement.agreement_id, agreement.name)" aria-label="View Responses"
              tooltip="View Responses">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="18" viewBox="0 0 22 18" fill="none">
                <path
                  d="M2.275 12.296C1.425 11.192 1 10.639 1 9C1 7.36 1.425 6.809 2.275 5.704C3.972 3.5 6.818 1 11 1C15.182 1 18.028 3.5 19.725 5.704C20.575 6.81 21 7.361 21 9C21 10.64 20.575 11.191 19.725 12.296C18.028 14.5 15.182 17 11 17C6.818 17 3.972 14.5 2.275 12.296Z"
                  stroke="#637381" stroke-width="1.5" />
                <path
                  d="M14 9C14 9.79565 13.6839 10.5587 13.1213 11.1213C12.5587 11.6839 11.7956 12 11 12C10.2044 12 9.44129 11.6839 8.87868 11.1213C8.31607 10.5587 8 9.79565 8 9C8 8.20435 8.31607 7.44129 8.87868 6.87868C9.44129 6.31607 10.2044 6 11 6C11.7956 6 12.5587 6.31607 13.1213 6.87868C13.6839 7.44129 14 8.20435 14 9Z"
                  stroke="#637381" stroke-width="1.5" />
              </svg>
            </button>
            <button (click)="edit(agreement.agreement_id)" aria-label="Edit Agreement" tooltip="Edit Agreement">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path
                  d="M17.7586 5.73201L14.268 2.24061C14.1519 2.1245 14.0141 2.0324 13.8624 1.96957C13.7107 1.90673 13.5482 1.87439 13.384 1.87439C13.2198 1.87439 13.0572 1.90673 12.9056 1.96957C12.7539 2.0324 12.6161 2.1245 12.5 2.24061L2.86641 11.875C2.74983 11.9906 2.65741 12.1283 2.59451 12.28C2.5316 12.4317 2.49948 12.5944 2.50001 12.7586V16.25C2.50001 16.5815 2.6317 16.8994 2.86612 17.1339C3.10054 17.3683 3.41849 17.5 3.75001 17.5H7.24141C7.40563 17.5005 7.5683 17.4684 7.71999 17.4055C7.87168 17.3426 8.00935 17.2502 8.12501 17.1336L17.7586 7.49998C17.8747 7.3839 17.9668 7.24609 18.0296 7.09442C18.0925 6.94274 18.1248 6.78017 18.1248 6.616C18.1248 6.45182 18.0925 6.28925 18.0296 6.13758C17.9668 5.9859 17.8747 5.84809 17.7586 5.73201ZM7.24141 16.25H3.75001V12.7586L10.625 5.88358L14.1164 9.37498L7.24141 16.25ZM15 8.49061L11.5086 4.99998L13.3836 3.12498L16.875 6.61561L15 8.49061Z"
                  fill="#637381" />
              </svg>
            </button>
          </div>
        </td>
      </tr>
      } @empty {
      <tr>
        <td colspan="5" class="py-10 text-center text-sm text-gray-500">
          No agreements found
        </td>
      </tr>
      }
      } @else {
      @for (_ of [].constructor(4); track $index) {
      <tr class="h-[57px]">
        <td class="pl-[16px] pr-2 border-b border-[#F1F3F5]">
          <div class="h-4 w-3/4 animate-pulse bg-gray-100 rounded"></div>
        </td>
        <td class="hidden lg:table-cell px-2 border-b border-[#F1F3F5]">
          <div class="h-4 w-20 animate-pulse bg-gray-100 rounded-full"></div>
        </td>
        <td class="hidden lg:table-cell px-2 border-b border-[#F1F3F5]">
          <div class="h-4 w-8 animate-pulse bg-gray-100 rounded"></div>
        </td>
        <td class="hidden lg:table-cell px-2 border-b border-[#F1F3F5]">
          <div class="h-4 w-24 animate-pulse bg-gray-100 rounded"></div>
        </td>
        <td class="pl-2 pr-[16px] border-b border-[#F1F3F5]">
          <div class="h-8 w-40 animate-pulse bg-gray-100 rounded-lg"></div>
        </td>
      </tr>
      }
      }
    </tbody>
  </table>
</div>

<ng-template #sortIcon let-column="column">
  @if (sortColumn === column) {
  <fa-icon [icon]="isAscending? faChevronUp : faChevronDown" class="text-[10px]" />
  }
</ng-template>